import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import Breadcrumbs from './breadcrumbs';
import Dropzone from 'components/dropzone';
import FileSystem from 'components/file_system';
import Placeholder from './placeholder';
import Table from './table';
import { createAttachment, createFolder } from './api';
import { rootFolder } from './config';

import './styles.scss';

// A wrapper around FileSystem components for attachments and attachment folders
export default function AttachmentsFileSystem({
  allowDeletion = true,
  attachable,
  attachments,
  folders,
  forUser,
  noPreviewComponent,
  preview,
  onAttachmentClick,
  onAttachmentCreated,
  onAttachmentsChange,
  onFoldersChange
}) {
  const [currentFolder, setCurrentFolder] = useState(rootFolder);
  const [previewFile, setPreviewFile] = useState(null);
  async function createNewFolder() {
    const folder = await createFolder(attachable.attachmentFoldersPath, 'New Folder', currentFolder.id);
    onFoldersChange([folder, ...folders]);
  }

  if (preview && previewFile) {
    return (
      <FileSystem.Preview
        file={previewFile}
        noPreviewComponent={noPreviewComponent}
        onExit={() => setPreviewFile(null)}
      />
    );
  }

  return (
    <div className="attachments-file-system">
      <Dropzone
        className="mb-4"
        placeholder={<Placeholder />}
        upload={(file, config) => createAttachment(attachable, file, config, currentFolder)}
        onSuccess={onAttachmentCreated}
      />

      <div className="actions row-eq-height">
        <Breadcrumbs
          currentFolder={currentFolder}
          folders={folders}
          onFolderClick={setCurrentFolder}
        />

        <AddControl aria-label="addFolder" onClick={createNewFolder}>
          Add folder
        </AddControl>
      </div>

      <Table
        allowDeletion={allowDeletion}
        attachments={attachments}
        currentFolder={currentFolder}
        folders={folders}
        forUser={forUser}
        onAttachmentsChange={onAttachmentsChange}
        onFileClick={preview ? setPreviewFile : onAttachmentClick}
        onFolderClick={setCurrentFolder}
        onFoldersChange={onFoldersChange}
      />
    </div>
  );
}

AttachmentsFileSystem.propTypes = {
  allowDeletion: PropTypes.bool,
  attachable: PropTypes.shape({
    attachmentFoldersPath: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  attachments: PropTypes.array,
  folders: PropTypes.array,
  forUser: PropTypes.shape({
    id: PropTypes.number.isRequired,
    apexAdmin: PropTypes.bool,
  }),
  noPreviewComponent: PropTypes.node,
  preview: PropTypes.bool,
  onAttachmentClick: PropTypes.func,
  onAttachmentCreated: PropTypes.func,
  onAttachmentsChange: PropTypes.func,
  onFoldersChange: PropTypes.func,
};
